import axios from "../AxiosInstance"

const getQuizzBytype = (knowledgeType, programId) => {
    return axios.get(`api/quizz?quizzType=${knowledgeType}&programId=${programId}`)
}

const getEvaluations = () => axios.get(`api/quizz`)

const getQuestionsByQuizzId = (quizzId) => axios.get(`api/question/questionQuizz/${quizzId}`)

const replyOnQuizz = (payload) => axios.post(`api/userQuizzQuestionResponse/multiple`, payload)

const getUserQuizzResponse = ({ userId, quizzId }) =>
    axios.get(`api/userQuizzQuestionResponse/user/${userId}/quizz/${quizzId}`)

export const KnowledgeService = {
    getQuestionsByQuizzId,
    getEvaluations,
    getQuizzBytype,
    replyOnQuizz,
    getUserQuizzResponse
}
